import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getPlatform } from '@core/registry';
import dayjs from 'dayjs';
var LOCAL_STORAGE_KEY = 'coveo-access-token';
var defaults = Object.freeze({
    token: '',
    expiration: 0
});
var getSaved = function getSaved() {
    var stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored === null) {
        // nothing stored
        return Object.assign({}, defaults);
    }
    try {
        var saved = JSON.parse(stored);
        return Object.assign({}, defaults, saved);
    } catch (e) {
        console.error(e);
        return Object.assign({}, defaults);
    }
};
var checkToken = function checkToken() {
    return _async_to_generator(function() {
        var unused;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        getPlatform().initialize()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    unused = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
export var AccessTokenUtils = {
    checkToken: checkToken,
    getToken: function getToken() {
        return getSaved().token;
    },
    setToken: function setToken(token, expires) {
        var expiration = dayjs().add(expires, 'seconds').valueOf();
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({
            token: token,
            expiration: expiration
        }));
    },
    getExpiration: function getExpiration() {
        return getSaved().expiration;
    },
    clear: function clear() {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
};

//# sourceMappingURL=AccessTokenUtils.js.map